module.exports = __webpack_public_path__ + "img/Vanuatu.18a5b3f8.svg";